<template>
    <div class="help-detail">
        <div class="panel">
            <div class="top-box">
                <span class="top-text">
                    <span @click="backIndex">帮助中心首页</span>
                    > <span @click="topNavClick1">{{level1.title||''}}</span>
                    > <span :class="{'disabled':!(level3.question && level3.question!=level2.title)}" @click="topNavClick2">{{level2.title||''}}</span>
                    <!-- <span class="disabled" v-if="level3.question && level3.question!=level2.title">> {{level3.question||''}}</span> -->
                </span>
                <div class="input-box">
                    <input type="text" placeholder="请搜索您遇到的问题" @keyup.enter="search" v-model="searchText" />
                    <i class="fonticon icon-sousuo" @click="search"></i>
                </div>
            </div>
            <el-menu
                v-if="menu.length"
                :default-active="active"
                :unique-opened="true"
                @select="handleSelect"
            >
                <div v-for="(item,i) in menu" :key="i">
                    <el-submenu :index="item.id">
                        <template slot="title">
                            <span>{{item.title}}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item
                                v-for="(items,j) in item.itemList"
                                :key="j"
                                :index="JSON.stringify(items)"
                            >{{items.title}}</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                </div>
            </el-menu>
            <div class="detail-box">
                <div class="detail-title">{{title}}</div>
                <div class="detail-content" v-if="type==1">
                    <div
                        class="detail-item"
                        v-for="(item,i) in list"
                        :key="i"
                        @click="handleSelect({type:2,id:item.id},1)"
                    >{{item.question}}</div>
                    <div class="empty-box" v-if="list.length==0">
                        <img src="@static/images/help/empty.png" alt />
                        <span>暂无相关内容</span>
                    </div>
                </div>
                <div class="answer-box detail-content" v-if="type==2">
                    <div class="answer-detail" v-html="answer"></div>
                    <div class="result-box">
                        <div class="result-title">以上内容是否解决您的问题？</div>
                        <div class="btn-list" v-if="status==''">
                            <div class="btn" @click="submit('ok');">
                                <img src="@static/images/help/ok.png" alt />
                                <span>已解决</span>
                            </div>
                            <div class="btn" @click="submit('no');">
                                <img src="@static/images/help/no.png" alt />
                                <span>未解决</span>
                            </div>
                        </div>
                        <div class="btn-list" v-if="status=='ok'">
                            <div class="btn big">
                                <img src="@static/images/help/ok_active.png" alt />
                                <span>感谢您给的赞，我们会继续加油的！</span>
                            </div>
                        </div>
                        <div class="btn-list" v-if="status=='no'">
                            <div class="btn big">
                                <img src="@static/images/help/no.png" alt />
                                <span>收到您的反馈，我们会努力改正！</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//当前实例组件
export default {
    data: () => ({
        searchText:"",
        type: "", //详情类型 1问题列表 2问题详情
        id: "",
        qid:"",
        status: "",
        active: "", //默认选中菜单
        menu: [],
        level1:{},
        level2:{},
        level3:{},
        title: "",
        answer: "",
        list: [],
        detail: {}
    }),
    watch: {
        $route: function(to, from) {
            this.type = this.$route.query.type;
            this.id = this.$route.query.id;
            this.isDetail = this.$route.query.isDetail;
            this.getDetail();
            this.setActiveData();
        }
    },
    created() {
        this.type = this.$route.query.type;
        this.id = this.$route.query.id;
        this.isDetail = this.$route.query.isDetail;
        this.getHelpList();
        this.getDetail();
    },
    methods: {
        // 返回帮助中心首页
        backIndex(){
            this.$router.push({
                path:'/help/index',
            })
        },
        // 顶部面包屑点击
        topNavClick1(){
            console.log(this.level1)
            this.handleSelect(this.level1.itemList[0]);
        },
        topNavClick2(){
            this.handleSelect(this.level2);
        },
        search(){
            if(this.searchText != "") {
                this.$router.push({
                    path:'/help/search',
                    query: {
                        searchText: this.searchText,
                    }
                })
            }
        },
        // 提交意见
        submit(type){
            this.status = type
            this.$http(
                {
                    url:'/api/mp/helpCenter/questionSupport',
                    type:'get',
                    params: {
                        id: this.qid||this.id,
                        type: type=='ok'?1:0
                    }
                }).then(res => {

                },error=>{
                    this.status = "";
                }
            );
        },
        // 菜单选中回调
        handleSelect(data, isDetail) {
            this.isDetail = isDetail;
            this.level3 = {};
            this.qid = "";
            this.status = "";
            try {
                if (typeof data == "string") {
                    data = JSON.parse(data);
                }
            } catch (error) {}
            this.type = data.type;
            this.id = data.id;
            console.log(data);
            location.href = this.getUrl(data, isDetail);
        },
        getUrl(item, isDetail) {
            let url = "#/help/detail?id=" + item.id + "&type=" + item.type;
            if(isDetail==1){
                url += "&isDetail=1&parentId="+this.level2.id
            }
            return url;
        },
        // 获取详情数据
        getDetail(isDetail) {
            if (this.$route.query.isDetail != 1) {
                this.$http({
                    url:'/api/mp/helpCenter/questionList',
                    type:'get',
                    params: {
                        classifyId: this.id
                    }
                }).then(res => {
                    if (this.type == 1) {
                        this.title = res.data.classifyTitle;
                        this.list = res.data.questionList;
                    } else {
                        this.title = res.data.question;
                        this.answer = res.data.answer;
                        this.qid = res.data.id;
                    }

                });
            } else {
                this.$http({
                    url:'/api/mp/helpCenter/questionDetail',
                    type:'get',
                    params: {
                        id: this.id
                    }
                }).then(res => {
                    this.title = res.data.question;
                    this.answer = res.data.answer;
                    this.level3 = res.data;
                });
            }
        },
        // 获取问题分类
        getHelpList() {
            this.$http({
                url:'/api/mp/helpCenter/classifyList',
                type:'get',
                params: {}
            }).then((res)=> {
                this.menu = res.data;
                this.setActiveData();
                console.log();
            });
        },
        // 设置当前选中的数据
        setActiveData(){
            this.menu.forEach(item1 => {
                item1.itemList.forEach(item2 => {
                    if (item2.id ==  this.$route.query.parentId) {//搜索跳转写入
                        this.level1 = item1;
                        this.level2 = item2;
                        this.active = JSON.stringify(item2);
                    }
                    if (item2.id == this.id) {
                        this.level1 = item1;
                        this.level2 = item2;
                        this.active = JSON.stringify(item2);
                    }
                });
            });
        },

    }
};
</script>
<style lang="scss">
@import "./detail.scss";
</style>
